import { type } from 'arktype';

export const UserSchema = type({
  // essential
  id: 'number',
  isActive: 'boolean',
  'published?': 'boolean | undefined | null',
  'username?': 'string | undefined | null',
  userNumber: 'string',
  'role?': '"ROLE_WEBSHOP_USER" | "ROLE_ADMIN" | undefined | null',
  // communication
  'fullName?': 'string | undefined | null',
  'email?': 'string | undefined | null',
  'phoneNumber?': 'string | undefined | null',
  'defaultCommunication?': 'string | undefined | null',
  // occupation
  'jobTitle?': 'string | undefined | null',
  'company?': 'string | undefined | null',
  // address
  'address?': 'string | undefined | null',
  'city?': 'string | undefined | null',
  'state?': 'string | undefined | null',
  'zipCode?': 'string | undefined | null',
  'country?': 'string | undefined | null',
  'notEligibleForPromotions?': 'boolean | undefined | null',
});

export type User = typeof UserSchema.infer;
